import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start">
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6">
              What Is the AllChinaBuy Spreadsheet?
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                The <strong>AllChinaBuy Spreadsheet</strong> is a carefully curated collection of verified product links, trusted seller databases, and high-quality finds from Chinese e-commerce platforms including Taobao, Weidian, and 1688. It serves as a comprehensive buying guide for international shoppers looking to access authentic products at wholesale-level prices.
              </p>
              <p>
                Our team of cross-border shopping experts has spent over five years researching and verifying sellers across these platforms. Every link in our spreadsheet has been personally tested, QC-checked, and rated for quality before being added to our database. We remove outdated links weekly and add fresh finds to ensure you always have access to the best products.
              </p>

              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 pt-4">
                Why Use Our AllChinaBuy Spreadsheet?
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4">
                {[
                  { icon: 'ri-refresh-line', title: 'Updated Weekly', desc: 'Fresh links and new finds every seven days' },
                  { icon: 'ri-shield-check-line', title: 'Verified Sellers', desc: 'Every seller personally vetted by our team' },
                  { icon: 'ri-star-line', title: 'Quality Ratings', desc: 'Detailed product quality scores out of 10' },
                  { icon: 'ri-scales-line', title: 'Price Comparisons', desc: 'See retail vs. spreadsheet savings' },
                  { icon: 'ri-truck-line', title: 'Shipping Tips', desc: 'Expert guidance on safe international shipping' },
                  { icon: 'ri-book-open-line', title: 'Beginner Guides', desc: 'Step-by-step instructions for first-time buyers' },
                ].map((item) => (
                  <div key={item.title} className="flex items-start gap-3 p-3 bg-background-100 rounded-lg">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className={item.icon}></i>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{item.title}</p>
                      <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 pt-6">
                <Link
                  to="/guide"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Read Buying Guide
                  <i className="ri-arrow-right-line"></i>
                </Link>
                <div className="flex items-center gap-8">
                  <div className="text-center">
                    <p className="text-2xl md:text-3xl font-heading font-bold text-accent-600">1000+</p>
                    <p className="text-xs text-foreground-500">Verified Finds</p>
                  </div>
                  <div className="text-center">
                    <p className="text-2xl md:text-3xl font-heading font-bold text-primary-600">Weekly</p>
                    <p className="text-xs text-foreground-500">Updated</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full lg:max-w-md">
            <div className="relative rounded-xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Curated%20collection%20of%20contemporary%20fashion%20pieces%20including%20footwear%20bags%20and%20accessories%20artistically%20arranged%20on%20warm%20cream%20surface%2C%20soft%20natural%20window%20light%20from%20left%2C%20minimalist%20editorial%20flat%20lay%20photography%2C%20warm%20beige%20sand%20and%20cream%20neutral%20tones%2C%20elegant%20composition%20with%20abundant%20negative%20space%20and%20refined%20shadows&width=700&height=900&seq=about-v2-side-001&orientation=portrait"
                alt="Trusted Sellers collection"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute top-4 left-4">
                <span className="inline-flex items-center px-3 py-1.5 bg-background-50/90 backdrop-blur-sm text-foreground-900 rounded-full text-xs font-semibold">
                  <i className="ri-verified-badge-fill text-primary-500 mr-1.5"></i>
                  Trusted Sellers
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-900/70 to-transparent p-5">
                <p className="text-background-50 text-sm font-medium">Verified Links</p>
                <p className="text-background-100/80 text-xs">QC Checked & Trusted</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}